import { Link } from "react-router-dom"

const NotFound: React.FC = () => {
    return (
        <main>
            <div className="container">

                <section className="section error-404 min-vh-100 d-flex flex-column align-items-center justify-content-center">
                    <h1>404</h1>
                    <h2>La página solicitada no fue encontrada.</h2>
                    <Link className="btn" to="/">Regresar al home</Link>
                </section>

            </div>
        </main>
    )
}

export default NotFound